
    import './styles.scoped.css';
    export default {
  "sticky-notifications": "awsui_sticky-notifications_154bi_1h0wm_5"
};
  